export default "__VITE_ASSET__TPY4u3jP__"